// import { Button } from 'flowbite-react'
import React from 'react'
import { Buttons } from '../Buttons'

export const ButtonGroup = ({ buttons = [] }) => {
   
    return (
        <div className='flex flex-col gap-5'>
            <div className='flex justify-center'>
                {!!buttons?.length && buttons?.map(item => <Buttons key={item?.text} {...item} className={`${item?.selected === true ? 'bg-primary-50' : ''} ${item?.className} `} />)}
            </div>
            <div className='content'>
                {(!!buttons?.length && buttons?.find(item => item?.selected)?.children) || ""}
            </div>
        </div>
    )
}
